import { c as _c } from "react/compiler-runtime";
import { Tabs as TabsPrimitive } from "@base-ui/react/tabs";
import { cn, cva, type VariantProps } from "../utils";
import { ScrollArea } from "./scroll-area";
function Tabs(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      orientation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const orientation = t1 === undefined ? "horizontal" : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("group/tabs flex gap-2 data-[orientation=horizontal]:flex-col", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== orientation || $[7] !== props || $[8] !== t2) {
    t3 = <TabsPrimitive.Root data-slot="tabs" data-orientation={orientation} orientation={orientation} className={t2} {...props} />;
    $[6] = orientation;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
const tabsListVariants = cva({
  base: "group/tabs-list relative inline-flex items-center text-muted-foreground group-data-[orientation=vertical]/tabs:h-fit group-data-[orientation=vertical]/tabs:flex-col",
  variants: {
    variant: {
      default: "h-9 w-fit justify-center rounded-lg border border-black/8 bg-muted/40 p-1 backdrop-blur-sm dark:border-white/10",
      line: "h-10 w-full gap-1.5 border-b border-muted bg-transparent"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
function TabsList(t0) {
  const $ = _c(28);
  let children;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      children,
      variant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const variant = t1 === undefined ? "default" : t1;
  const t2 = variant === "default" && "top-[var(--active-tab-top)] h-[var(--active-tab-height)] rounded-md bg-muted shadow-sm ring-1 ring-black/5 dark:shadow-none dark:ring-white/10";
  const t3 = variant === "line" && "bottom-0 h-0.5 bg-foreground";
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = cn("pointer-events-none absolute left-[var(--active-tab-left)] z-0 w-[var(--active-tab-width)] transition-[width,height,top,left] duration-200 ease-out will-change-[transform,width,height]", t2, t3);
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <TabsPrimitive.Indicator data-slot="tabs-indicator" aria-hidden={true} renderBeforeHydration={true} className={t4} />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const indicator = t5;
  if (variant === "line") {
    let t6;
    if ($[10] !== className || $[11] !== variant) {
      t6 = cn(tabsListVariants({
        variant
      }), className);
      $[10] = className;
      $[11] = variant;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    let t7;
    if ($[13] !== children || $[14] !== indicator || $[15] !== props || $[16] !== t6 || $[17] !== variant) {
      t7 = <ScrollArea className="w-full" hideScrollbar={true} scrollFade={true}><TabsPrimitive.List data-slot="tabs-list" data-variant={variant} className={t6} {...props}>{indicator}{children}</TabsPrimitive.List></ScrollArea>;
      $[13] = children;
      $[14] = indicator;
      $[15] = props;
      $[16] = t6;
      $[17] = variant;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    return t7;
  }
  let t6;
  if ($[19] !== className || $[20] !== variant) {
    t6 = cn(tabsListVariants({
      variant
    }), className);
    $[19] = className;
    $[20] = variant;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== children || $[23] !== indicator || $[24] !== props || $[25] !== t6 || $[26] !== variant) {
    t7 = <TabsPrimitive.List data-slot="tabs-list" data-variant={variant} className={t6} {...props}>{indicator}{children}</TabsPrimitive.List>;
    $[22] = children;
    $[23] = indicator;
    $[24] = props;
    $[25] = t6;
    $[26] = variant;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}
function TabsTrigger(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("relative z-10 inline-flex h-full flex-1 cursor-pointer items-center justify-center gap-1.5 rounded-md border border-transparent px-2 text-sm font-medium whitespace-nowrap text-muted-foreground transition-colors", "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1 focus-visible:outline-ring", "disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50", "data-[active]:cursor-default data-[active]:text-foreground", "[&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg]:text-muted-foreground/70 data-[active]:[&_svg]:text-foreground [&_svg:not([class*='size-'])]:size-4", "group-data-[orientation=vertical]/tabs:w-full group-data-[orientation=vertical]/tabs:justify-start", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <TabsPrimitive.Tab data-slot="tabs-trigger" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function TabsContent(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex-1 text-sm outline-none", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <TabsPrimitive.Panel data-slot="tabs-content" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { Tabs, TabsContent, TabsList, TabsTrigger, tabsListVariants };